import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Navbar  from './components/Navbar';
import Footer  from './components/Footer';
import FloatButtons from './components/FloatButtons';

import Home    from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import About   from './pages/About';
import Contact from './pages/Contact';

/* Sayfa değişince en üste scroll */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/"          element={<Home />} />
        <Route path="/hizmetler" element={<Services />} />
        <Route path="/projeler"  element={<Projects />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/iletisim"  element={<Contact />} />
        {/* 404 fallback */}
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <FloatButtons />
    </Router>
  );
}
